<template>
  <carousel
    :per-page="1"
    :mouse-drag="false"
    :autoplay="true"
    :autoplayTimeout="5000"
    :loop="true"
    :indicators="true"
    @page-change="random_image()"
  >
    <slide v-for="d in data" v-bind:key="d.img_url">
      <div class="box">
        
        <img :src="selectedImage.img_url" style="height:auto; width:100%;" />
         <a href="https://snakekit.indiansnakes.org/" target="_blank"> <button id="btns" class="centerbutton btn btn-success btn-lg" style="background-color: #ecc348;border-color:#ecc348;"><b>Buy Rescue Kit</b></button></a>
      </div>
    </slide>
  </carousel>
</template>
<script>
export default {
  data() {
    return {
      data: [
      { img_url: require('@/assets/Longest-fang-snake.jpg'), link: '' },
      { img_url: require('@/assets/russells-viper.jpg'), link: '' },
      { img_url: require('@/assets/vine-snake.jpg'), link: '' },
      { img_url: require('@/assets/serpent.jpg'), link: '' },
      { img_url: require('@/assets/krait-hexa-scales.jpg'), link: '' },
      { img_url: require('@/assets/Rescue-kit.jpg'), link: 'https://snakekit.indiansnakes.org/' }
      ],
      selectedImage: "",
      slide: false
    };
  },
  mounted() {
    this.random_image();
  },
  methods: {
    random_image() {
      var $this = this;
      const idx = Math.floor(Math.random() * $this.data.length);
      $this.selectedImage = $this.data[idx];
    }
  }
};
</script>
<style>


h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
.bg {
  height: 500px;
  width: 100%;
}
.box {
  position: relative;
}
.box .text {
  position: absolute;
  z-index: 999;
  margin: 0 auto;
  left: 0;
  right: 0;
  top: 40%;
  text-align: center;
  width: 60%;
  color: black;
  font-size: 30px;
}
@media (min-width: 375px) {
  .text {
    font-size: 20px;
    color: black;
  }
}
@media (min-width: 1281px) {
  .text {
    font-size: 30px;
    color: black;
  }
}
.VueCarousel-pagination {
  position: absolute !important;
  margin-bottom: 500px !important;
  margin-top: 500px !important;
}
@media (min-width: 1281px) and (max-width: 1800px) {
  .VueCarousel-pagination {
    position: absolute !important;
    margin-bottom: 380px !important;
    margin-top: 380px !important;
  }
  .centerbutton {
    margin: 0 auto;
    text-align: right;
    position:absolute;
    z-index:50;
    top:10%;
    left:91%;
    margin-top:-23px;
    margin-left:-50px;
}
}
@media (min-width: 1025px) and (max-width: 1280px) {
  .VueCarousel-pagination {
    position: absolute !important;
    margin-bottom: 380px !important;
    margin-top: 380px !important;
  }
  .centerbutton {
    margin: 0 auto;
    text-align: right;
    position:absolute;
    z-index:50;
    top:20%;
    left:89%;
    margin-top:-23px;
    margin-left:-50px;
}
}
@media (min-width: 768px) and (max-width: 1024px) {
  .VueCarousel-pagination {
    position: absolute !important;
    margin-bottom: 250px !important;
    margin-top: 250px !important;
  }
   .centerbutton {
    margin: 0 auto;
    text-align: right;
    position:absolute;
    z-index:50;
    top:20%;
    left:84%;
    margin-top:-23px;
    margin-left:-50px;
}
}
@media (min-width: 481px) and (max-width: 767px) {
  .VueCarousel-pagination {
    position: absolute !important;
    margin-bottom: 150px !important;
    margin-top: 150px !important;
  }
   .centerbutton {
    margin: 0 auto;
    text-align: right;
    position:absolute;
    z-index:50;
    top:50%;
    left:74%;
    margin-top:-23px;
    margin-left:-50px;
}
}
@media (min-width: 320px) and (max-width: 480px) {
  .VueCarousel-pagination {
    position: absolute !important;
    margin-bottom: 50px !important;
    margin-top: 50px !important;
  }
   .centerbutton {
    margin: 0 auto;
    text-align: right;
    position:absolute;
    z-index:50;
    top:35%;
    left:60%;
    margin-top:-23px;
    margin-left:-50px;
}
}
.VueCarousel-pagination {
  display: none !important;
}
</style>